import { updateCurrentCompanySettings } from '@Actions';
import { InputAutocomplete, MenuItemType } from '@innovyze/stylovyze';
import { getValue } from '@Selectors';
import { useFormikContext } from 'formik';
import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomInfoCard } from './GeneralSettingsFields.styles';
import { CompanySettingsFull } from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import { Option } from '../GeneralSettings';
import { coordinateSystems } from './CoordinateSystems';
import { useGlobalization } from '@Translations';

export default function DefaultImportCoordinateSystem() {
	const { t } = useGlobalization();
	const dispatch = useDispatch();

	const { setValues } = useFormikContext<CompanySettingsFull>();
	const setGeneralSettingsFields = useSetGeneralSettingsFields();
	const companySettingsErrors =
		useSelector(getValue).companySettings.companySettingsErrors || {};

	const setCurrentEPSGField = (
		e: ChangeEvent<HTMLInputElement>,
		option?: Option,
	) => {
		if (option) {
			const defaultImportCoordinateSystemAuthority = 'EPSG';
			const defaultImportCoordinateSystemCode = option.key;

			setGeneralSettingsFields({
				defaultImportCoordinateSystemAuthority,
				defaultImportCoordinateSystemCode,
			});
			dispatch(
				updateCurrentCompanySettings({
					defaultImportCoordinateSystemAuthority,
					defaultImportCoordinateSystemCode,
				}),
			);
			setValues(vals => ({
				...vals,
				defaultImportCoordinateSystemAuthority,
				defaultImportCoordinateSystemCode,
			}));
		}
	};

	return (
		<CustomInfoCard
			fullHeight
			title={t('Default Import Coordinate System')}>
			<InputAutocomplete
				options={coordinateSystems
					.filter(item => item.authority === 'EPSG')
					.map((item): MenuItemType => {
						return { key: item.code, value: item.displayName };
					})}
				fieldAttrs={{ name: 'defaultImportCoordinateSystemCode' }}
				label={t('Manhole Surveys')}
				dataCy="coordinateSystemManholeSurveys"
				onChange={setCurrentEPSGField}
				networkError={
					companySettingsErrors.defaultImportCoordinateSystemCode
				}
				autocompleteProps={{
					disableClearable: true,
				}}
			/>
		</CustomInfoCard>
	);
}
